import { NO_MORE_REWARD_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
export const noMoreRewardModal = {
    [NO_MORE_REWARD_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
